import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { setLocalActiveTab } from "../content/local"; // ✅ make sure this export exists

const TABS = ["news", "events", "about", "history", "contacts", "businesses"];

export default function LocalTabs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { label } = useParams(); // city label in the route

  const active = useSelector((s) => s.local?.activeTab) || "news";

  // ✅ these were missing
  const listRef = useRef(null);
  const btnRefs = useRef({});
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  const onClick = (t) => {
    dispatch(setLocalActiveTab(t));
    // push ?tab=…
    const base = `/local/${encodeURIComponent(label || "")}`;
    navigate(`${base}?tab=${t}`, { replace: false });
  };

  // position underline relative to scroll
  const recalc = () => {
    const list = listRef.current;
    const btn = btnRefs.current[active];
    if (!list || !btn) return;
    const listBox = list.getBoundingClientRect();
    const btnBox = btn.getBoundingClientRect();
    setIndicator({
      left: btnBox.left - listBox.left + list.scrollLeft,
      width: btnBox.width,
    });
  };

  // initial + on active change
  useEffect(recalc, [active]);

  // on scroll + resize
  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    const onScroll = () => recalc();
    list.addEventListener("scroll", onScroll, { passive: true });
    const onResize = () => recalc();
    window.addEventListener("resize", onResize);
    return () => {
      list.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  // make the active tab visible on change
  useEffect(() => {
    const el = btnRefs.current[active];
    el?.scrollIntoView({ inline: "center", behavior: "smooth", block: "nearest" });
  }, [active]);

  return (
    <div className="tabs" role="tablist" aria-label="Local sections">
      <div className="tabs__list" ref={listRef}>
        {TABS.map((t) => (
          <button
            key={t}
            ref={(el) => (btnRefs.current[t] = el)}
            className={`tablink ${active === t ? "is-active" : ""}`}
            onClick={() => onClick(t)}
            role="tab"
            aria-selected={active === t}
            type="button"
          >
            {t[0].toUpperCase() + t.slice(1)}
          </button>
        ))}
        <span
          className="tabs__indicator"
          style={{ transform: `translateX(${indicator.left}px)`, width: indicator.width }}
          aria-hidden="true"
        />
      </div>
    </div>
  );
}